import React, {Component} from 'react';
import {Switch, Route} from 'react-router-dom';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import {withStyles} from '@material-ui/core/styles';

import {http, route, api, config, diagnostic} from './common/common';
import Menubar from './main/Menubar';
import PreLogin from './main/PreLogin';
import Viewer from './main/Viewer';
import Tasking from './main/Tasking';
import Report from './main/Report';
import Settings from './main/Settings';

const styles = (theme) => {
    return {
        menu: {
            position: 'fixed',
            top: 0,
            height: 48,
            left: 0,
            right: 0,

        },
        view: {
            position: 'absolute',
            left: 0,
            right: 0,
            top: 48,
            bottom: 0,
            zIndex: -1,
            '&$positionFix': {
                position: 'fixed',
            },
        },
        positionFix: {},
        versionLabel: {
            position: 'fixed',
            bottom: 2,
            right: 2,
            color: theme.palette.primary.light,
            fontSize: 8,
        },
    };
}

class Main extends Component {
    constructor(props) {
        super(props);

        this._appList = null;
        this._sharedProps = {};
        this._cancelToken = http.CancelToken.source();
    }

    componentWillUnmount = () => {
        if (this._cancelToken) {
            this._cancelToken.cancel();
        }
    }

    render = () => {
        return (
            <div>
                {this._renderRoute()}
                {this._renderVersion()}
            </div>
        );
    }

    _renderRoute = () => {
        return (
            <Switch>
                <Route
                    path='/:base*/main/prelogin'
                    render={this._renderPreLogin}
                />
                <Route
                    path='/:base*/main/viewer'
                    render={this._renderViewer}
                />
                <Route
                    path='/:base*/main/tasking'
                    render={this._renderTasking}
                />
                <Route
                    path='/:base*/main/report'
                    render={this._renderReport}
                />
                <Route
                    path='/:base*/main/settings'
                    render={this._renderSettings}
                />
            </Switch>
        );
    }

    _renderPreLogin = (props) => {
        const passProps = {...Object.assign({}, this.props, {classes: null})};

        return (
            <div>
                <PreLogin
                    {...passProps}
                    {...props}
                    sharedProps={this._sharedProps}
                    setSharedProps={this._setSharedProps}
                    onDone={this._onPreLoginDone}
                    onError={this._handleError}
                />
            </div>
        );
    }

    _renderViewer = (props) => {
        const passProps = {...Object.assign({}, this.props, {classes: null})};
        const {classes} = this.props;

        this._requestAppList('viewer');

        if (!this._appList) {
            return null;
        }

        return (
            <div>
                <div className={classes.menu}>
                    <Menubar
                        {...passProps}
                        {...props}
                        label='Viewer'
                        appList={this._appList}
                    />
                </div>
                <div className={classNames(classes.view, classes.positionFix)}>
                    <Viewer
                        {...passProps}
                        {...props}
                        sharedProps={this._sharedProps}
                        setSharedProps={this._setSharedProps}
                        onError={this._handleError}
                    />
                </div>
            </div>
        );
    }

    _renderTasking = (props) => {
        const passProps = {...Object.assign({}, this.props, {classes: null})};
        const {classes} = this.props;

        this._requestAppList('tasking');

        if (!this._appList) {
            return null;
        }

        return (
            <div>
                <div className={classes.menu}>
                    <Menubar
                        {...passProps}
                        {...props}
                        label='Tasking'
                        appList={this._appList}
                    />
                </div>
                <div className={classNames(classes.view, classes.positionFix)}>
                    <Tasking
                        {...props}
                        {...passProps}
                        sharedProps={this._sharedProps}
                        setSharedProps={this._setSharedProps}
                        onError={this._handleError}
                    />
                </div>
            </div>
        );
    }

    _renderReport = (props) => {
        const passProps = {...Object.assign({}, this.props, {classes: null})};
        const {classes} = this.props;

        this._requestAppList('report');

        if (!this._appList) {
            return null;
        }

        return (
            <div>
                <div className={classes.menu}>
                    <Menubar
                        {...passProps}
                        {...props}
                        label='Report'
                        appList={this._appList}
                    />
                </div>
                <div className={classNames(classes.view, classes.positionFix)}>
                    <Report
                        {...props}
                        {...passProps}
                        sharedProps={this._sharedProps}
                        setSharedProps={this._setSharedProps}
                        onError={this._handleError}
                    />
                </div>
            </div>
        );
    }

    _renderSettings = (props) => {
        const passProps = {...Object.assign({}, this.props, {classes: null})};
        const {classes} = this.props;

        this._requestAppList('settings');

        if (!this._appList) {
            return null;
        }

        return (
            <div>
                <div className={classes.menu}>
                    <Menubar
                        {...passProps}
                        {...props}
                        label='Settings'
                        appList={this._appList}
                    />
                </div>
                <div className={classNames(classes.view, classes.positionFix)}>
                    <Settings
                        {...props}
                        {...passProps}
                        onError={this._handleError}
                    />
                </div>
            </div>
        );
    }

    _renderVersion = () => {
        const {classes} = this.props;

        return (
            <div className={classes.versionLabel}>
                version: {config.buildVersion}
            </div>
        );
    }

    _onPreLoginDone = () => {
        const routePath = (this.props.location.state && this.props.location.state.routeTo) ?
            this.props.location.state.routeTo : '';

        if (routePath && routePath.startsWith('/main/')) {
            this._requestAppList(routePath.slice(6));
            return;
        }

        this._requestAppList('');
    }

    _routeToBestMatchApp = (suggestedApp) => {
        const appList = this._appList;

        if (appList && appList.length > 0 && appList[0]) {
            if (suggestedApp) {
                for (const app of appList) {
                    if (app === suggestedApp) {
                        route(this, '/main/' + suggestedApp, '');
                        return;
                    }
                }
            }

            route(this, '/main/' + appList[0], '');
        } else {
            route(this, '/main/settings', '');
        }
    }

    _setSharedProps = (props) => {
        this._sharedProps = Object.assign(this._sharedProps, props);
    }

    _handleError = (error) => {
        diagnostic.errorDump(this.props.getAccessCode(), error);

        if (error.response && error.response.status === 401) {
            if (error.response.data.error === 'invalid_client') {
                this.props.setError(
                    'Session Expired',
                    'expired',
                    'Your session has either expired or is no longer valid',
                    () => {
                        this.props.setAccessCode('');
                        route(this, '/home', '');
                    });

                return;
            } else if (error.response.data.error === 'invalid_privilege') {
                this.props.setError(
                    'Invalid Privilege',
                    'privilege',
                    'You do not have privilege to access the service',
                    () => {
                        this._appList = null;
                    });

                return;
            }
        }

        if (!error.response) {
            error.response = {
                data: {},
            };
        }

        if (typeof(error.response.data) === 'string') {
            error.response.data = {
                error_description: error.response.data,
            };
        } else if (!error.response.data.error_description) {
            error.response.data = {
                error_description: 'Unknown error occurred',
            };
        }

        if (!error.response.data.error_title) {
            error.response.data.error_title = 'Error';
        }

        if (error.response.data.error === 'warn_only') {
            this.props.setError(
                error.response.data.error_title,
                'generic',
                error.response.data.error_description);

            return;
        }

        this.props.setError(
            error.response.data.error_title,
            'generic',
            error.response.data.error_description,
            () => {
                if (error.response.data.error !== 'no_request' &&
                    error.response.data.error !== 'no_response') {
                    this.props.setAccessCode('');
                }

                route(this, '/home', '');
            });
    }

    _requestAppList = async (suggestedApp) => {
        try {
            if (this._appList) {
                return;
            }

            const response = await http.get(api.privilege() + '/app', {
                params: {
                    'access_code': this.props.getAccessCode(),
                    'mode': 'user',
                },
                cancelToken: this._cancelToken.token,
            });

            if (response.data.access) {
                this._appList = response.data.access;
            } else {
                this._appList = [];
            }

            const appList = this._appList;

            if (appList[appList.length - 1] === 'demo') {
                this._appList.pop();
                this._demoMode = true;
            }

            this._appList.push('settings');
            this._appList.push('faq');
            this._appList.sort(this._sortAppList)

            this._routeToBestMatchApp(suggestedApp)
        } catch (error) {
            if (http.isCancel(error)) {
                return;
            }

            this._appList = [];
            this._appList.push('settings');
            this._appList.push('faq');

            this._routeToBestMatchApp(suggestedApp)
        }
    }

    _mapToIndex = (name) => {
        switch (name) {
            case 'viewer': return 0;
            case 'tasking': return 1;
            case 'report': return 2;
            case 'settings': return 3;
            case 'faq': return 4;
            case 'organization': return 10;
            default: return 100;
        }
    }

    _sortAppList = (left, right) => {
        const l = this._mapToIndex(left);
        const r = this._mapToIndex(right);
        return l-r;
    }
}

Main.propTypes = {
    setError: PropTypes.func.isRequired,
    getAccessCode: PropTypes.func.isRequired,
    setAccessCode: PropTypes.func.isRequired,
}

export default withStyles(styles)(Main);
